module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg5-144bb17867c3e7a9a241b53385a4842b.jpg";